<template>
  <div class="full-height d-flex flex-column ">

    <pc-header activeIndex="sign-up"></pc-header>
    <div class="container">
      <div class="row">
        <div class="col">
          <h4 class="mt-5 ml-4">Register to start using PyCrunch</h4>
          <el-form ref="form" :rules="rules" :model="sign_up_form" class="mt-4" label-width="150px"
                   style="max-width: 500px">
            <el-form-item label="E-Mail" prop="email">
              <el-input v-model="sign_up_form.email"></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input type="password" autocomplete="new-password" v-model="sign_up_form.password"></el-input>
            </el-form-item>
            <el-form-item label="Repeat Password" prop="password_repeat">
              <el-input type="password" autocomplete="new-password" v-model="sign_up_form.password_repeat"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="startRegistration">Sign Up</el-button>
            </el-form-item>
            {{sign_up_error}}
          </el-form>
        </div>
      </div>
    </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
  import PcHeader from '@/components/pc-header.component'
  import axios from 'axios'
  import config from '@/config'
  import {mapActions, mapState} from 'vuex'
  import PcFooter from '../views/PcFooter'

  export default {
    name: 'register.page',
    components: {
      PcFooter,
      PcHeader},
    data () {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password'))
        } else {
          if (this.sign_up_form.password_repeat !== '') {
            this.$refs.form.validateField('password_repeat')
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password again'))
        } else if (value !== this.sign_up_form.password) {
          callback(new Error('Two inputs don\'t match!'))
        } else {
          callback()
        }
      }
      return {

        sign_up_form: {
          email: '',
          password: '',
          password_repeat: '',
        },
        rules: {
          email: [
            {
              required: true,
              message: 'Your email is required',
              trigger: 'blur',
            },
            {
              type: 'email',
              message: 'Please input correct email address',
              trigger: ['blur', 'change'],
            },
          ],
          password: [
            {
              required: true,
              validator: validatePass,
              trigger: 'blur',
            },
            {
              min: 8,
              message: 'Your password is too short. Please use at least 8 symbols',
              trigger: 'blur',
            },
          ],
          password_repeat: [
            {
              required: true,
              validator: validatePass2,
              trigger: ['blur', 'change'],
            },
          ],
        },
        error: '',
      }
    },
    computed: {
      ...mapState(['count', 'sign_up_error', 'is_logged_in']),
    },
    methods: {
      ...mapActions(['willRegister']),

      async startRegistration () {
        let is_valid = false
        this.$refs.form.validate((valid) => {
          if (valid) {
            is_valid = true
          } else {
            console.log('error submit!!')
            return false
          }
        })
        if (!is_valid) {
          return
        }
        let payload = {
          email: this.sign_up_form.email,
          password: this.sign_up_form.password,
        }
        await this.willRegister(payload)
        if (this.is_logged_in) {
          this.$router.push('/my-profile')
        }
      },
    },
  }
</script>

<style scoped>
  .full-height {
    min-height: 100vh;
    flex-direction: column;
  }
</style>